import { render, staticRenderFns } from "./seeReform.vue?vue&type=template&id=f5e78712"
import script from "./seeReform.vue?vue&type=script&lang=js"
export * from "./seeReform.vue?vue&type=script&lang=js"
import style0 from "./seeReform.vue?vue&type=style&index=0&id=f5e78712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports